import { ISSUES } from "@/data/issues";

export default function LearnScreen({ active, selected, onNext }) {
  return (
    <div className={`screen ${active ? "active" : ""}`} id="screen-learn">
      <div className="screen-inner">
        <div className="screen-header">
          <div className="screen-label">Step 2 of 4</div>
          <h2 className="screen-title">Why your voice matters</h2>
          <p className="screen-desc">Laws and elections decide these things every day — even for people who can't vote yet.</p>
        </div>
        <div className="facts-container">
          {selected.map((id, i) => {
            const d = ISSUES.find((x) => x.id === id);
            return (
              <div className="fact-card" key={id} style={{ animationDelay: i * 0.12 + "s" }}>
                <div className="fact-label"><span className="fact-emoji">{d.emoji}</span><span className="fact-issue">{d.name}</span></div>
                <p className="fact-text">{d.fact}</p>
                <p className="fact-why">Why voting matters: {d.why}</p>
              </div>
            );
          })}
        </div>
        <button className="btn-primary" onClick={onNext} style={{ maxWidth: 300, width: "100%", marginTop: 8 }} data-testid="learn-next-btn">Make My Pledge →</button>
      </div>
    </div>
  );
}
